<template>
	<WodeLayout>

		<div class="relative cmt-1">
			<el-card header="账户信息">
				<el-form label-width="100px" label-position="right">
					<el-form-item label="图书馆名称">
						{{localHouseInfo.name}}
					</el-form-item>
					<el-form-item label="用户名">
						{{userInfo.username}}
					</el-form-item>
				</el-form>
			</el-card>

			<el-card header="数据统计">

				<div class="relative f fx">
					<el-statistic class="f-1" title="已发布" :value="countActivity"></el-statistic>
					<el-statistic class="f-1" title="已申请" :value="countJoinContract"></el-statistic>
					<el-statistic class="f-1" title="收到的申请" :value="countMainContract"></el-statistic>
					<el-statistic class="f-1" title="总量"
						:value="countActivity+countJoinContract+countMainContract"></el-statistic>
				</div>
			</el-card>

		</div>

	</WodeLayout>
</template>

<script>
	import WodeLayout from '@/layout/WodeLayout.vue'




	import mixin from '@/utils/mixin';
	export default {
		mixins: [mixin],
		components: {
			WodeLayout,
		},
		data() {
			return {

				countActivity: 0,
				countMainContract: 0,
				countJoinContract: 0,


			}
		},
		mounted() {
			this.load();
		},
		methods: {
			load() {
				request({
					url: '/api/house/wode/home',
					data: {},
					success: resp => {
						this.countActivity = resp.data.countActivity || 0;
						this.countMainContract = resp.data.countMainContract || 0;
						this.countJoinContract = resp.data.countJoinContract || 0;
					}
				})

			},



		}
	}
</script>

<style>




</style>